import { FormattedDate } from 'react-intl'
import { TableCell as MuiTableCell, TableRow, styled } from '@mui/material'
import { Link, Typography } from '@carto/meridian-ds/components'

import { App, AppShare } from 'features/apps/types'
import AppsCardMedia from 'features/apps/ui/AppsCard/AppsCardMedia'
import AccountAppsMenuWrapper from '../AccountAppsMenuWrapper'
import ShareOptionLabel, { ShareOptionLabelProps } from 'features/common/ui/sharing/ShareOptionLabel'
import { CommonPrivacy } from 'features/common'
import { privateOptionDescriptor } from 'features/common/ui/sharing/ShareOptionPrivate'
import { useMemo } from 'react'
import {
  getSharedWithGroupsOptionDescriptor,
  sharedWithAllOptionDescriptor
} from 'features/common/ui/sharing/ShareOptionShared/ShareOptionShared'
import { Group } from 'features/groups'

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  '&.MuiTableCell-root': {
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75)
  }
}))
function AccountAppsTableRow({ app }: { app: App }) {
  const shareOptions: Record<string, ShareOptionLabelProps> = useMemo(
    () => ({
      [AppShare.Private]: {
        ...privateOptionDescriptor,
        description: undefined,
        size: 'small',
        isDefault: false,
        selected: false
      },
      [AppShare.SharedWithAll]: {
        ...sharedWithAllOptionDescriptor,
        description: undefined,
        size: 'small',
        isDefault: false,
        selected: true
      },
      [AppShare.SharedWithGroups]: {
        ...getSharedWithGroupsOptionDescriptor(app?.groups as Group[]),
        description: undefined,
        size: 'small',
        isDefault: false,
        selected: true // selected due to styling (grey otherwise)
      }
    }),
    [app]
  )

  const getShareOptions = ({ groups, privacy }: App) => {
    const hasGroups = groups?.length && groups.length > 0

    if (privacy === CommonPrivacy.Shared && hasGroups) {
      return shareOptions[AppShare.SharedWithGroups]
    }

    if (privacy === CommonPrivacy.Shared) {
      return shareOptions[AppShare.SharedWithAll]
    }

    return shareOptions[AppShare.Private]
  }

  return (
    <TableRow aria-label={`app - ${app.title}`}>
      <TableCell width={58}>
        <AppsCardMedia app={app} />
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="textPrimary" weight="strong">
          {app.title}
        </Typography>
        <Link variant="caption" color="textSecondary" href={app.url} target="_blank" rel="noopener noreferrer">
          {app.url}
        </Link>
      </TableCell>
      <TableCell width={140}>
        <Typography variant="body2" color="textSecondary">
          <FormattedDate value={app.created_at} year="numeric" month="short" day="numeric" />
        </Typography>
      </TableCell>
      <TableCell width={140}>
        <ShareOptionLabel {...getShareOptions(app)} size="small" />
      </TableCell>
      <TableCell width={36} align="right">
        <AccountAppsMenuWrapper app={app} />
      </TableCell>
    </TableRow>
  )
}

export default AccountAppsTableRow
